import * as React from "react";
import { useRecordContext } from "react-admin";
import { Box, Typography } from "@mui/material";

export const JsonField = ({ source, label, maxHeight = 240 }) => {
  const record = useRecordContext();
  if (!record) return null;
  // "__all__" = tout l'enregistrement (onglets « Brut »).
  const value = source === "__all__" ? record : record[source];
  if (value == null) return <span>—</span>;
  const text =
    typeof value === "string" ? value : JSON.stringify(value, null, 2);
  return (
    <Box>
      {label && (
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
      )}
      <Box
        component="pre"
        sx={{
          bgcolor: "#f5f7fa",
          p: 1.5,
          borderRadius: 1,
          fontFamily: "monospace",
          fontSize: 12,
          maxHeight,
          overflow: "auto",
          margin: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {text}
      </Box>
    </Box>
  );
};

export default JsonField;
